export default __webpack_public_path__ + "static/media/hedef-500bin_5_copy_2-05.9cdf129d.svg";